import React from "react";

// TODO: don't hardcore music files
const MUSIC_FILES = [
    "18 Minute Heavenly Playboi Carti Mix (528Hz).mp4", "Kanye West - Future Bounce.mp3", "arm_and_leg.mp3", "cancun.mp3", "city_in_the_sky.mp3", "dj_windows_xp_the_day_i_met_susan.mp3", "illusion.mp3", "long_time.mp3", "magnolia.mp3", "miss_the_rage.mp3", "miss_the_rage_remake.mp3", "molly.mp3", "molly_slowed.mp3", "molly_slowed_639hz.mp3", "pissy.mp3", "playboi carti mix.mp4", "shawty.mp3", "yandi.mp4"
]

export function Music() {
    MUSIC_FILES.sort()
    return (<div className="flex min-h-screen flex-col items-center px-4 py-10 text-center text-black">
        <h1 className="mb-4 text-4xl">Music</h1>
        {MUSIC_FILES.map(file => (
            <div key={file} className="m-1 text-xl">
                <a href={"/music/" + file} className="text-black hover:underline">
                    {file}
                </a>
                <br/>
            </div>
        ))}
    </div>)
}
